/**
 * An `sms:` link that opens the phone's own Messages app with people and a message filled in.
 *
 * The three platforms disagree on the one thing that matters — how several recipients are
 * separated and how the body is attached:
 *   iOS      `sms:/open?addresses=+1…,+1…&body=…`  (the `/open` form takes a body with several
 *            numbers; the bare `sms:a,b&body=` form drops it on recent iOS)
 *   Android  `sms:+1…;+1…?body=…`                  (`;` between numbers, `?` before the body)
 *   other    `sms:+1…,+1…?body=…`
 * The text is sent BY the person from THEIR number — nothing goes through Portal's SMS line,
 * so there is nothing to opt out of and the invite reads as a text from a friend.
 */
export function smsHref(numbers, body, platform = detectPlatform()) {
  const nums = (numbers || []).map(cleanNumber).filter(Boolean);
  const text = encodeURIComponent(body || '');
  if (platform === 'ios') return `sms:/open?addresses=${nums.join(',')}&body=${text}`;
  if (platform === 'android') return `sms:${nums.join(';')}?body=${text}`;
  return `sms:${nums.join(',')}?body=${text}`;
}

/** Digits and a leading `+` only — a contact's number comes with spaces, dashes and brackets. */
export function cleanNumber(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  const plus = s.startsWith('+') ? '+' : '';
  const digits = s.replace(/\D/g, '');
  return digits.length >= 7 ? `${plus}${digits}` : '';
}

export function detectPlatform(ua = (typeof navigator !== 'undefined' ? navigator.userAgent : '')) {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

/** Apple's Messages and Android's SMS apps both choke past a few dozen recipients; keep a text a text. */
export const MAX_SMS_RECIPIENTS = 25;

/** What the text says. The link is last so every Messages app previews it. */
export function inviteSmsBody({ name, url }) {
  const who = name ? `${name} invited you to Portal` : 'You’re invited to Portal';
  return `${who} — where your people are. Accept the invite: ${url}`;
}
